import firebase from 'firebase';
import {isUserId} from '../Users';
import {auth, db} from '../Firebase/main';
import {DataBaseNodes} from '../Constants';


/**
 * Returns a Firebase Realtime Database reference to messages node by provided cid.
 *
 * Throws an error if current user is not authenticated and private chat is selected.
 *
 * @param cid Chat ID. Refers to a user's id or room's id.
 */
export function getMessagesReference(cid: string): firebase.database.Reference {
    let path;
    if (isUserId(cid)) {
        const myId = auth.currentUser?.uid;
        if (!myId) throw new Error('User is not authenticated!');
        path = urlify(DataBaseNodes.private_messages, myId, cid);
    }
    else {
        path = urlify(DataBaseNodes.public_messages, cid);
    }
    return db.ref(path);
}


/**
 * Checks if uid equals to current Firebase user's id.
 *
 * Returns false if no authenticated user found.
 * @param uid string
 */
export function isMyId(uid: string): boolean {
    const myId = auth.currentUser?.uid;
    return Boolean(myId && myId === uid);
}


/**
 * Simply joins an array of strings with a slash
 *
 * @param nodes url nodes
 */
export function urlify(...nodes: string[]): string {
    return nodes.join('/');
}


const DEV = false;

const ENABLE_LOGS = DEV;


export function log(...logs: any[]) {
    ENABLE_LOGS && console.log('Thread:', ...logs);
}


export function err(...errs: any[]) {
    ENABLE_LOGS && console.error('Thread:', ...errs);
}


export function warn(...warns: any[]) {
    ENABLE_LOGS && console.warn('Thread:', ...warns);
}